<script setup>
    import { ref, getCurrentInstance } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue'
    import adminPartnerService from "../../services/partner/adminPartnerService";
    import KSAInputGeneralPhoneNum from "../../../../components/ui-components/input/KSAInputGeneralPhoneNum.vue";
    import _ from 'lodash'

    const { $regex, $toast, $number } = getCurrentInstance().appContext.config.globalProperties;

    const route = useRoute();
    const router = useRouter();
    const loadingStore = usePageLoadingStore();

    const modal = ref(null)
    const modalContent = ref('');
    const editorRef = ref(null)

    const input = ref({
        partnerName: "",     // 담당기관명
        partnerStartYmd: "", // 담당기간(시작일)
        partnerEndYmd: "",   // 담당기간(종료일)
        ceoName: "",         // 대표자명
        partnerPhoneNum: "", // 담당기관대표연락처
        partnerEmail: "",    // 담당기관이메일
        chargeName: "",      // 담당자명
        chargePhoneNum: "",  // 담당자연락처
        chargeEmail: "",     // 담당자이메일
    })

    // 담당기관 등록
    const create = () => {
        const request = _.cloneDeep(input.value);
        const {
            partnerName,     // 담당기관명
            partnerStartYmd, // 담당기간(시작일)
            partnerEndYmd,   // 담당기간(종료일)
            ceoName,         // 대표자명
            partnerPhoneNum, // 담당기관대표연락처
            partnerEmail,    // 담당기관이메일
            chargeName,      // 담당자명
            chargePhoneNum,  // 담당자연락처
            chargeEmail,     // 담당자이메일
        } = request;

        if(!partnerName) {
            modalContent.value = ["담당기관명을 입력하세요"];
            modal.value.show();
            return false;
        }
        if(partnerStartYmd == null || partnerStartYmd === '' || $number(partnerStartYmd) === '0') {
            modalContent.value = ["담당기간(시작일)을 입력하세요."];
            modal.value.show();
            return false;
        }
        if(partnerEndYmd == null || partnerEndYmd === '' || $number(partnerEndYmd) === '0'){
            modalContent.value = ["담당기간(종료일)을 입력하세요."];
            modal.value.show();
            return false;
        }
        if(partnerStartYmd > partnerEndYmd){
            modalContent.value = ["담당기간(시작일)은 담당기간(종료일)보다 빨라야합니다."];
            modal.value.show();
            return false;
        }
        if(!partnerPhoneNum){
            modalContent.value = ["담당기관 연락처를 입력하세요."];
            modal.value.show();
            return false;
        } else {
            if(!$regex.generalPhoneNum.test(partnerPhoneNum)) {
                modalContent.value = ["유효한 담당기관 연락처를 입력하세요."];
                modal.value.show();
                return false;
            }
        }
        if(!partnerEmail){
            modalContent.value = ["담당기관 이메일을 입력하세요."];
            modal.value.show();
            return false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailRegex.test(partnerEmail)) {
                modalContent.value = ["유효한 담당기관 이메일 형식을 입력하세요."];
                modal.value.show();
                return false;
            }
        }
        if(chargePhoneNum) {
            if(!$regex.generalPhoneNum.test(chargePhoneNum)) {
                modalContent.value = ["유효한 담당자 연락처를 입력하세요."];
                modal.value.show();
                return false;
            }
        }
        if(chargeEmail) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailRegex.test(chargeEmail)) {
                modalContent.value = ["유효한 담당자 이메일 형식을 입력하세요."];
                modal.value.show();
                return false;
            }
        }
        loadingStore.loading = true;
        adminPartnerService.createPartner(request)
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    modalContent.value = ["담당기관을 등록하였습니다."];
                    await modal.value.show();
                    goDetail(result);
                } else {
                    $toast("error", "담당기관 등록을 실패하였습니다.");
                }

            }).catch( (res) =>  {
                loadingStore.loading = false;
                $toast("error", res.response.data.result.message);
        });
    }

    // 담당기관 등록 취소 (목록으로 이동)
    const cancel = async () => {
        modalContent.value = ["담당기관 등록이 취소되었습니다."];
        await modal.value.show();
        router.push({ name: "PartnerList" });
    }

    // 담당기관상세로 가기
    const goDetail = (partnerId) => {
        router.push({ name: "PartnerDetail", params: {id: partnerId} });
    }

</script>

<template>
    <div class="container">
        <div class="flex-wrap admin">
            <SNBAdmin class="snb" />
            <div class="content">
                <div class="sub-title">
                    <h3>담당기관 등록</h3>
                    <p><span>* 표시는 필수 입력사항</span> 입니다.</p>
                </div>
                <div class="table-form">
                    <table class="vertical">
                        <colgroup>
                            <col width="200px" />
                            <col />
                        </colgroup>
                        <tr>
                            <th class="mark">담당기관명</th>
                            <td>
                                <KSAInput class="text-box" v-model="input.partnerName" max-length="50" placeholder="담당기관명을 입력해주세요."/>
                            </td>
                        </tr>
                        <tr>
                            <th class="mark">담당기간</th>
                            <td class="text-box">
                                <div style="display: inline-block;">
                                    <KSADatepickerTerms
                                        :startDate="input.partnerStartYmd"
                                        :endDate="input.partnerEndYmd"
                                        @update:startDate="(value)=> input.partnerStartYmd = value"
                                        @update:endDate="(value)=> input.partnerEndYmd = value"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>대표자명</th>
                            <td>
                                <KSAInput class="text-box" v-model="input.ceoName" max-length="50" placeholder="담당기관 대표자명을 입력해주세요."/>
                            </td>
                        </tr>
                        <tr>
                            <th class="mark">담당기관 연락처</th>
                            <td>
                                <KSAInputGeneralPhoneNum class="text-box" v-model="input.partnerPhoneNum" max-length="13" placeholder="담당기관 연락처를 입력해주세요."/>
                            </td>
                        </tr>
                        <tr>
                            <th class="mark">담당기관 이메일</th>
                            <td>
                                <KSAInput class="text-box" v-model="input.partnerEmail" max-length="50" placeholder="담당기관 이메일을 입력해주세요."/>
                            </td>
                        </tr>
                        <tr>
                            <th>담당자명</th>
                            <td>
                                <KSAInput class="text-box" v-model="input.chargeName" max-length="50" placeholder="담당자명을 입력해주세요."/>
                            </td>
                        </tr>
                        <tr>
                            <th>담당자 연락처</th>
                            <td>
                                <KSAInputGeneralPhoneNum class="text-box" v-model="input.chargePhoneNum" max-length="13" placeholder="담당자 연락처를 입력해주세요."/>
                            </td>
                        </tr>
                        <tr>
                            <th>담당자 이메일</th>
                            <td>
                                <KSAInput class="text-box" v-model="input.chargeEmail" max-length="50" placeholder="담당자 이메일을 입력해주세요."/>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="btn-wrap space-between">
                    <KSASecondaryButton class="gray_button" text="취소" @click="cancel" />
                    <KSAPrimaryButton text="등록" @click="create" />
                </div>
            </div>
        </div>
    </div>
    <AlertModal ref="modal" :content="modalContent"/>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

</style>